module.exports = __webpack_public_path__ + "static/media/boreadape_bg_transparent.b70aa1b3.png";